import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { useState, useEffect } from 'react';
import logo from '../assets/images/Logo.png';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { Button } from '@mui/material';
const containerStyle = {
	fontSize: '19px',
	fontFamily: 'Calibri, sans-serif',
};

const pricingListStyle = {
	listStyleType: 'decimal',
	marginLeft: '0.5in',
};

const nestedListStyle = {
	listStyleType: 'upper-alpha',
	marginLeft: '1em',
};

export default function MmemberPlans() {
	const [memberPlan, setMemberPlan] = useState(null);
	const [selectedPlanId, setSelectedPlanId] = useState(null);
	const navigate = useNavigate();
	useEffect(() => {
		const fetchData = async () => {
			try {
				const response = await axios.get(
					'https://api.getcogen.com/api/getMemberPlans',
					{
						headers: { Accept: 'application/json' },
					}
				);
				setMemberPlan(response?.data?.member_plans);
				console.log('Data retrieved successfully:', response?.data?.plans);
			} catch (error) {
				toast.error(error.response?.data?.message);
				console.error('Error fetching data:', error.message);
			}
		};

		fetchData();
	}, []);
	const handlePlanUpdate = async () => {
		try {
			const accessToken = JSON.parse(localStorage.getItem('cogen_user_profile'))?.accessToken;
			const planId = parseInt(selectedPlanId);
			const response = await axios.post('https://api.getcogen.com/api/user_update_plan',
				{ plan_id: planId },
				{
					headers: {
						Accept: 'application/json',
						Authorization: `Bearer ${accessToken}`,
					},
				}
			);
			if (response?.data?.success == true) {
				toast.success(response?.data?.message);
				navigate('/stripe');
				return;
			}
		} catch (error) {
			toast.error('Failed to update plan id');
			console.log(error);
		}
	};
	const logout = () => {
		const tokenId = localStorage.getItem('cogen_user_profile');

		axios.delete(
			'http://ec2-3-13-248-4.us-east-2.compute.amazonaws.com/dev/logout/' +
			tokenId
		);
		localStorage.clear();
		// localStorage.setItem('userType', 'public');
		window.location.href = `/`;
	};

	const SixYear = memberPlan?.[0]?.time_limit;
	const OneYear = memberPlan?.[1]?.time_limit;
	return (
		<Container>
			<Row className='py-5 mt-1 align-items-center'>
				<Col sm={12}>
					<img
						src={logo}
						alt='logo'
						onClick={logout}
						style={{
							height: '10vmin',
							marginLeft: '105px',
							marginBottom: '30px',
							cursor: 'pointer',
						}}
					/>
					<h1>Welcome to Cogen</h1>
					<p className='font-italic text-muted mb-0'>
						Choose between our plan{""} {SixYear} and {" "}{OneYear} , each offering
						unique benefits. Find the perfect plan tailored to your needs and
						elevate your experience with Cogen.
					</p>
					<div style={containerStyle}>
						<ol style={pricingListStyle}>
							<ol style={nestedListStyle}>
								{memberPlan?.map(plan => (
									<li>
										<div
											className='form-check'
											style={{ marginTop: '10px' }}
											key={plan.id}
										>
											<input
												className='form-check-input'
												type='radio'
												name='plan_id'
												id={`flexRadioDefault${plan.id}`}
												value={plan.id.toString()} // Convert the id to a string as it is used as the value
												onChange={e => setSelectedPlanId(e.target.value)}
												required
											/>
											<label
												className='form-check-label'
												style={{ fontWeight: 'bold' }}
											>
												{plan?.plan_name} Program (${plan?.price})
											</label>{' '}
											<br />
											{/* <label className='form-check-label font-italic text-muted mb-0'>
                                        One Initial Setup Charges ${plan.annual_fee}
                                    </label>
                                    <label className='form-check-label font-italic text-muted mb-0'>
                                        Maintenance Charges ${plan.mentanance_fee}
                                    </label> */}
											{plan.plan_name === 'Basic' && (
												<>
													<label
														className='form-check-label font-italic text-muted mb-0'
														htmlFor='flexRadioDefault2'
													>
														The {plan?.time_limit} plan costs (${plan?.price})
														and automatically renews for another{' '}
														{plan?.time_limit} with auto debit. Cancellation is
														allowed only with at least 15 days remaining before
														expiration; otherwise, it renews automatically after
														completion.
													</label>
												</>
											)}
											{plan.plan_name === 'Premium' && (
												<>
													<label
														className='form-check-label font-italic text-muted mb-0'
														htmlFor='flexRadioDefault2'
													>
														The {plan?.time_limit} plan costs (${plan?.price})
														and will automatically renew for another{' '}
														{plan?.time_limit} period after the completion of
														the first year. The user can cancel the plan only 15
														days before the year ends.
													</label>
												</>
											)}
										</div>
									</li>
								))}
							</ol>
						</ol>
					</div>
				</Col>
				<Col sm={10}>
					<Button
						onClick={handlePlanUpdate}
						sx={{ float: 'right', marginLeft: '12px' }}
						variant='contained'
					>
						Update
					</Button>
					<Button variant='contained' sx={{ float: 'right', background: 'red' }} onClick={() => logout()}>
						LOGOUT
					</Button>
				</Col>
			</Row>
		</Container>
	);
}
